<template>
  <div>
    <div class="loading-mask" v-if="data.countdown > 0"></div>
    <transition name="fade">
      <div class="loading" v-if="data.countdown > 0" @click="openUrl">
        <template v-if="isPc">
          <img v-if="data.urlType === 'img'" :src="data.pcUrl" alt=""></img>
          <video v-else :src="data.pcUrl"></video>
        </template>
        <template v-else>
          <img v-if="data.urlType === 'img'" :src="data.phoneUrl" alt=""></img>
          <video v-else :src="data.phoneUrl"></video>
        </template>
        <div class="close" @click.stop="close">
          <span>{{ data.countdown }}</span>
          {{ En ? 'Close' : '关闭公告'}}
          <img src="https://static.worldaic.com.cn/2024/web/static/images/loading-close.png" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'loading',
  data() {
    return {
      data: {},
      timer: null
    }
  },
  created() {
    this.getData()
  },
  watch: {
    openAd(v) {
      if (v) {
        this.getData()
      }
    }
  },
  methods: {
    getData() {
      protal.getConfigByCode('official_website_guide').then(res => {
        this.data = res.data.data
        this.data.urlType = 'img'
        this.timer = setInterval(() => {
          if (this.data.countdown) {
            this.data.countdown--
          }
          if (this.data.countdown <= 0) {
            clearInterval(this.timer)
            this.showAd(false)
          }
        }, 1000)
      })
      // protal.getJson("gw_home_splash", (data) => {
      //   this.data = data[0] || null
      //   console.log(JSON.stringify(this.data, 551))
      //   this.timer = setInterval(() => {
      //     if (this.data.countdown) {
      //       this.data.countdown--
      //     }
      //     if (this.data.countdown <= 0) {
      //       clearInterval(this.timer)
      //       this.showAd(false)
      //     }
      //   }, 1000)
      // });
    },
    close() {
      this.data.countdown = 0
      this.showAd(false)
      clearInterval(this.timer)
    },
    openUrl() {
      this.$jsAPI('track','exhibitorAdClick',
          {
            'flowName_var': this.data.advertName
          }
      );
      gio('track','exhibitorAdClick',
          {
            'flowName_var': this.data.advertName
          }
      );
      if (!this.data.linkUrl) return
      window.open(this.data.linkUrl, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.loading-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .58);
  z-index: 98;
}

@media screen and (min-width: 769px) {
  .loading {
    position: fixed;
    left: 1.1rem;
    top: calc(50% - 3rem);
    z-index: 99;
    width: 17rem;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;

    img, video {
      display: flex;
      width: 100%;
      height: auto;
      cursor: pointer;
    }

    .close {
      position: absolute;
      right: 1.24rem;
      top: .28rem;
      height: .36rem;
      background: rgba(0, 0, 0, .4);
      border-radius: .18rem;
      font-size: .18rem;
      color: #fff;
      display: flex;
      align-items: center;
      line-height: 1;
      padding-right: .12rem;
      padding-left: .08rem;
      cursor: pointer;

      span {
        width: .24rem;
        height: .16rem;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: .16rem;
        color: #FF3333;
        text-align: center;
        margin-right: .06rem;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        font-family: sybold;
      }

      img {
        margin-left: .12rem;
        width: .12rem;
        height: .12rem;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: scale(0);
    margin-left: 6.5rem;
    top: 0.5rem;
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .loading {
    position: fixed;
    left: .55rem;
    top: calc(50% - 5rem);
    width: 6.4rem;
    height: 10rem;
    z-index: 99;

    img, video {
      display: flex;
      width: 100%;
      height: auto;
      cursor: pointer;
    }

    .close {
      position: absolute;
      right: .32rem;
      top: .28rem;
      height: .48rem;
      background: rgba(0, 0, 0, .4);
      border-radius: .24rem;
      font-size: .26rem;
      color: #fff;
      display: flex;
      align-items: center;
      line-height: 1;
      padding-right: .12rem;
      padding-left: .08rem;
      cursor: pointer;

      span {
        width: .38rem;
        height: .24rem;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: .24rem;
        color: #FF3333;
        text-align: center;
        margin-right: .06rem;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        font-family: sybold;
      }

      img {
        margin-left: .12rem;
        width: .16rem;
        height: .16rem;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: scale(0);
    margin-left: 2.8rem;
    top: -2.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue